<template>
  <footer>
    <b-container>
      <b-row>
        <b-col class="footer-left" md>
          <div
            v-for="navItem in navUrls"
            :key="navItem.text"
          >
            <b-link
              :href="navItem.url"
              :target="navItem.isTargetBlank ? '_blank' : ''"
            >
              {{ navItem.text }}
            </b-link>
          </div>
        </b-col>

        <b-col md="2" class="empty-col"></b-col>

        <b-col md>
          <FooterSocialMedia title="AROUND THE WEB"/>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="footer-right" md>
          <div class="copyright">
            Site design inspired by <b-link href="https://colorlib.com/wp/template/ronin/">Colorlib Ronin</b-link>.
            <br>
            <b>Copyright © 2022</b> All rights reserved | James Choi
          </div>
        </b-col>
      </b-row>
    </b-container>
  </footer>
</template>

<script>
import FooterSocialMedia from './FooterSocialMedia.vue';

import navUrls from '../assets/data/nav-urls.json';

export default {
  name: 'SiteFooter',
  components: {
    FooterSocialMedia
  },
  data() {
    return {
      navUrls
    };
  }
}
</script>

<style lang="scss" scoped>
footer {
  flex-shrink: 0;
  color: #fff;
  background-color: $darkGrey;
  padding-top: 50px;
  padding-bottom: 50px;
  width: 100%;

  a {
    padding: 0;
    color: white;
    font-size: 18px;
    font-weight: bold;
    text-decoration: none;

    &:hover {
      color: $primaryGreen;
    }
  }

  .empty-col {
    height: 30px;
  }

  .copyright {
    margin-top: 40px;
  }
}
</style>
